import { traverseTree } from "src/standard/ts/trees";

export function getNodesBetween<TItem extends { children?: TItem[] }>(
  treeNodes: readonly TItem[] | null | undefined,
  anchor: TItem | null | undefined,
  nextAnchor: TItem | null | undefined,
) {
  if (!anchor || !nextAnchor) {
    return undefined;
  }

  // We can do selection from top down or bottom up,
  // so we first traverse the tree and see which we find first
  let startNode: TItem | undefined;
  let endNode: TItem | undefined;
  for (const node of traverseTree(treeNodes)) {
    if (node === anchor) {
      startNode = anchor;
      endNode = nextAnchor;
      break;
    }

    // We found "next" first, so consider it the start
    if (node === nextAnchor) {
      startNode = nextAnchor;
      endNode = anchor;
      break;
    }
  }

  let foundStart = false;
  const rangeNodes: TItem[] = [];
  for (const node of traverseTree(treeNodes)) {
    if (node === startNode) {
      foundStart = true;
    }

    // Skip until found
    if (!foundStart) {
      continue;
    }

    rangeNodes.push(node);

    // Done
    if (node === endNode) {
      break;
    }
  }

  return rangeNodes;
}
